/**
 * Table patterns. Universal table components consume these.
 * Marketing comparison tables may opt out and use the primitives directly.
 *
 * Token note (theme-bridge): surfaces, borders, hovers all flow through
 * semantic theme tokens so the same UniversalTable renders correctly in
 * both the portal (light) and marketing (dark) themes.
 */

export const tablePatterns = {
  wrapper: 'overflow-hidden rounded border border-border bg-card',
  scroll: 'overflow-x-auto',
  table: 'w-full text-sm',
  header: 'bg-muted font-mono text-[11px] uppercase tracking-[0.15em] text-muted-foreground',
  headerCell: 'px-4 py-2.5 text-left',
  headerCellSortable: 'px-4 py-2.5 text-left cursor-pointer select-none hover:text-foreground',
  body: 'divide-y divide-border',
  row: 'transition-colors hover:bg-muted',
  rowClickable: 'transition-colors hover:bg-primary/5 cursor-pointer',
  cell: 'px-4 py-3',
  cellNumeric: 'px-4 py-3 text-right tabular-nums',
  empty: 'p-12 text-center text-sm text-muted-foreground',
  density: {
    compact: 'px-3 py-2',
    default: 'px-4 py-3',
    relaxed: 'px-4 py-4',
  },
} as const;
